import { RouteObject } from "react-router-dom";
import FormOfForms from "../pages/Forms/FormOfForms/FormOfForms";
import FormsPage from "../pages/Forms/Forms";
import Home from "../pages/Home/Home";
import CallBack from "../pages/Login/CallBack";
import Login from "../pages/Login/Login";
import FieldsPage from "../pages/Fields/Fields";
import UsersPage from "../pages/Users/Users";
import AccessDenied from "../pages/AccessDenied/AccessDenied";
import NotFound from "../pages/NotFound/NotFound";
import FormBuilder from "../pages/Forms/FormBuilder/FormBuilder";
import ErrorServer from "../pages/ErrorServer/ErrorServer";

const routers: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/login",
    children: [
      {path: "", element: <Login />},
      {path: "oauth2/code/cognito", element: <CallBack />}
    ]
  },
  {
    path: "formularios",
    children: [
      { path: "", element: <FormsPage /> },
      { path: "crear", element: <FormBuilder /> },
      { path: ":id", element: <FormBuilder /> },
      { path: "ver/:id", element: <FormOfForms /> },
    ],
  },
  {
    path: "campos",
    children: [
      { path: "", element: <FieldsPage /> },
      { path: "crear", element: <FormOfForms /> },
      { path: ":id", element: <FormOfForms /> },
    ],
  },
  {
    path: "usuarios",
    children: [
      { path: "", element: <UsersPage /> },
      { path: "crear", element: <FormOfForms /> },
      { path: ":id", element: <FormOfForms /> },
    ],
  },
  {
    path: 'acceso-restringido',
    element: <AccessDenied />
  },
  {
    path: 'error-server',
    element: <ErrorServer />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routers;
